import { DescriptionFieldProps } from "@rjsf/utils";
import { Markdown } from "../../Common/__styles__/Markdown";
import { Description } from "./__styles__/DescriptionFieldTemplate";

export const DescriptionFieldTemplate = (props: DescriptionFieldProps) => {
  const { description, id } = props;
  return (
    <Description id={id}>
      {typeof description === "string" ? (
        <Markdown markdown={description} />
      ) : (
        description
      )}
    </Description>
  );
};
